import { Button } from "takeat-design-system-ui-kit";
import styled from "styled-components";

export const WppAlertButtonComponent = styled(Button)`
  color: #C8131B;
  text-align: center;
  font-family: Poppins;
  font-size: 8px;
  font-style: normal;
  font-weight: 600;
  line-height: 115%;
  background: #F6F6F6;
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 98px;
  padding: 0 8px;
`

export const WppAlertButtonNumber = styled.div`
  height: 0;

  > div {
    display: flex;
    width: 12px;
    height: 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    color: #FFF;
    font-family: Poppins;
    font-size: 8px;
    font-style: normal;
    font-weight: 600;
    line-height: 12px;
    border-radius: 50px;
    background: #C8131B;
    left: 44px;
    bottom: 6px;
    padding: 0 0 0 1px;
  }
`